import React, { Component, ErrorInfo, ReactNode } from 'react';

import { Notifier } from '@airbrake/browser';
import { Toast } from '@thinkific/toga-react';

type Props = {
  children: ReactNode;
};

type State = {
  error: Error | null;
  info: ErrorInfo | null;
};
/*
 * Error Boundaries can catch some errors (not all)
 * https://reactjs.org/docs/error-boundaries.html
 */
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const projectId = Number(process.env.AIRBRAKE_PROJECT_ID);
    const projectKey = process.env.AIRBRAKE_PROJECT_KEY || '';
    const environment = process.env.AIRBRAKE_PROJECT_ENV || '';

    const airbrake = new Notifier({
      projectId,
      projectKey,
      environment,
    });

    airbrake.addFilter((notice) => {
      if (environment === 'development') {
        return null;
      }
      return notice;
    });

    airbrake.notify({
      error,
      params: { info },
    });

    this.setState({
      error,
      info,
    });
  }

  render() {
    const { children } = this.props;
    const { error, info } = this.state;

    return (
      <>
        {error ? (
          <>
            {/* We can render error details or fail quietly */}
            {/* @ts-ignore */}
            <Toast type="alert">Internal error</Toast>
            <details>
              <pre>
                {error && error.toString()}
                {info?.componentStack}
              </pre>
            </details>
          </>
        ) : null}
        {children}
      </>
    );
  }
}

export default ErrorBoundary;
